import moment from 'moment';
import { TimeUnits } from '../../util/index.js';
import { VoucherCategory } from '../vouchers/index.js';
import { getDeposits } from './vouchers.js';
export const expiredVouchers = (caseVouchers, foundations, countryCode, config) => {
    return caseVouchers.filter((v) => isVoucherExpired(v, caseVouchers, foundations, countryCode, {
        removeMonths: config?.removeMonths,
        customExpiration: config?.customExpiration,
    }));
};
export const expirationDatesCaseVouchers = (caseVouchers, foundations, countryCode, config) => {
    return caseVouchers.map((v) => {
        const calculatedExpirationDate = voucherExpirationDate(v, caseVouchers, foundations, countryCode, {
            removeMonths: config?.removeMonths,
            customExpiration: config?.customExpiration,
        });
        return {
            caseVoucherId: v.caseVoucherId,
            calculatedExpirationDate: calculatedExpirationDate
                ? calculatedExpirationDate.toISOString()
                : null,
            currentExpirationDate: v.expirationDate,
        };
    });
};
export const isVoucherExpired = (caseVoucher, caseVouchers, foundations, countryCode, config) => {
    const expirationDate = voucherExpirationDate(caseVoucher, caseVouchers, foundations, countryCode, {
        removeMonths: config?.removeMonths,
        customExpiration: config?.customExpiration,
    });
    return expirationDate ? moment().isAfter(expirationDate, 'day') : false;
};
export const voucherExpirationDate = (caseVoucher, caseVouchers, foundations, countryCode, config) => {
    if (caseVoucher.category === VoucherCategory.TRANSACTION) {
        return null;
    }
    const countryStandardExpiration = getCountryStandardExpiration(countryCode);
    const normalExpiration = config?.customExpiration?.normal
        ? config.customExpiration.normal
        : countryStandardExpiration.withoutFoundation;
    const normalExpirationWithFoundation = config?.customExpiration?.foundation
        ? config.customExpiration.foundation
        : countryStandardExpiration.withFoundation;
    let relevantDate = caseVoucher.expirationFromDate || caseVoucher.date;
    let relevantExpirationDuration = normalExpiration;
    const normalizedData = normalizeData(getDeposits(caseVouchers), foundations);
    for (let i = 0; i < normalizedData.length; i++) {
        const element = normalizedData[i];
        switch (element.type) {
            case 'deposit':
                if (moment(relevantDate)
                    .add(relevantExpirationDuration, TimeUnits.YEARS)
                    .isBefore(moment(element.date).add(normalExpiration, TimeUnits.YEARS))) {
                    relevantDate = element.date;
                    relevantExpirationDuration = normalExpiration;
                }
                break;
            case 'foundation':
                if (moment(relevantDate)
                    .add(relevantExpirationDuration, TimeUnits.YEARS)
                    .isBefore(moment(element.date).add(normalExpirationWithFoundation, TimeUnits.YEARS))) {
                    relevantDate = element.date;
                    relevantExpirationDuration = normalExpirationWithFoundation;
                }
                break;
        }
    }
    return config?.removeMonths
        ? moment(relevantDate)
            .add(relevantExpirationDuration, TimeUnits.YEARS)
            .subtract(config.removeMonths, TimeUnits.MONTHS)
        : moment(relevantDate).add(relevantExpirationDuration, TimeUnits.YEARS);
};
const normalizeData = (deposits, foundations) => {
    const result = [];
    deposits.forEach((d) => {
        result.push({
            date: d.date,
            type: 'deposit',
        });
    });
    foundations &&
        foundations.forEach((f) => {
            result.push({
                date: f.signedAt || f.date,
                type: 'foundation',
            });
        });
    return result.sort((a, b) => (moment(a.date).isAfter(b.date) ? 1 : -1));
};
const getCountryStandardExpiration = (countryCode) => {
    switch (countryCode) {
        case 'DK':
            return { withFoundation: 10, withoutFoundation: 3 };
        case 'GL':
            return { withFoundation: 20, withoutFoundation: 5 };
        default:
            return { withFoundation: 10, withoutFoundation: 3 };
    }
};
//# sourceMappingURL=expiration.js.map